import { render } from "./LoginForm.component.vue?vue&type=template&id=22027f85&ts=true"
import script from "./LoginForm.component.vue?vue&type=script&lang=ts"
export * from "./LoginForm.component.vue?vue&type=script&lang=ts"

import "./LoginForm.component.vue?vue&type=style&index=0&id=22027f85&lang=css"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__